import { render, staticRenderFns } from "./sync-logs.vue?vue&type=template&id=7e972562"
import script from "./sync-logs.vue?vue&type=script&lang=js"
export * from "./sync-logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports